import { Typography } from '@mui/material'
import { useSearchCells } from 'components/cell-browsing/cellSearchHelpers'
import SectionCard from 'components/shared/SectionCard'
import useRunDetailsSlice from 'redux/slices/hooks/useRunDetailsSlice'
import CellImagesGallery from './CellImagesGallery'

interface ImagesSectionProps {
  runId: string
  totalCellCount?: number
}

const ImagesSection = ({ runId, totalCellCount }: ImagesSectionProps): JSX.Element => {
  const { runDetails } = useRunDetailsSlice()

  const { result: cellData, isLoading } = useSearchCells({
    runId,
    sortOrderKey: 'TIME_ASC',
    page: runDetails.pageCount,
    quadrant: 1,
  })

  // Use totalCellCount from run if provided (feature enabled), otherwise use API count
  const displayCount = totalCellCount ?? cellData?.count

  return (
    <SectionCard title="Images">
      {displayCount ? (
        <CellImagesGallery cellData={cellData} totalCellCount={totalCellCount} />
      ) : (
        <Typography>
          {isLoading && 'Loading cell images...'}
          {!isLoading && "Didn't capture any cell images as part of this run."}
        </Typography>
      )}
    </SectionCard>
  )
}

export default ImagesSection
